import { Container, FormControlLabel, styled, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import Alert from 'components/Alert';
import ButtonWithSpinner from 'components/ButtonWithSpinner';

export const StyledContainer = styled(Container)`
  max-width: 500px !important;
  padding: 2rem 1rem !important;
`;

export const Header = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;

  ${theme.breakpoints.up('md')} {
    margin-bottom: 40px;
  }
`;

export const Title = styled(Typography)`
  margin: 0;

  ${theme.breakpoints.up('sm')} {
    font-size: 40px;
  }
`;

export const SubTitle = styled(Typography)`
  font-size: 20px;
  margin-bottom: 16px;
  margin: 0;
`;

export const StyledButtonWithSpinner = styled(ButtonWithSpinner)`
  margin-top: 24px;
`;

export const StyledAlert = styled(Alert)`
  margin-top: 1rem;
`;

export const MarketingPreferences = styled('div')`
  padding: 1.5rem 0 1rem;
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 0;
  padding-top: 1rem;
  user-select: none;

  .MuiTypography-body1 {
    font-size: 16px;
  }
`;
